import React from 'react';
import type { ElementRef, Ref } from 'react';

import { styled, theme } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import styles from './Spacer.styles';
export interface SpacerProps {
  /**
   * The CSS `width` or `height` property
   */
  axis?: 'horizontal' | 'vertical';

  /**
   * The spacer size
   */
  size?: keyof typeof theme.space;

  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLSpanElement>;
}

const DEFAULT_TAG = 'span';

const SpacerEl = styled(DEFAULT_TAG, styles);

const Spacer = React.forwardRef<ElementRef<typeof DEFAULT_TAG>, SpacerProps>(
  (props, ref) => {
    const { size = 1, ...rest } = props;

    return (
      <SpacerEl
        ref={ref}
        css={{
          $$size: theme.space[size],
        }}
        {...rest}
      />
    );
  }
);

Spacer.displayName = 'Spacer';

export default Spacer;
